import { gql } from '@apollo/client';

export interface IGetWorkShiftIdResponse {
  getWorkShiftPaymentOverviewData: {
    id: number;
  } | null;
}
export const GET_WORKSHIFT_ID = gql`
  query getWorkshiftId {
    getWorkShiftPaymentOverviewData {
      id
    }
  }
`;
